import { Box, styled, Typography } from '@mui/material';

export const CategoryPremiumStyled = styled(Typography)({
  fontWeight: '400',
  fontSize: '33px',
  lineHeight: '46.2px',
  letterSpacing: '0.25%',
  '@media (max-width: 743px)': {
    fontSize: '23px',
  },
});

export const BenefitsPreviewContainerV2 = styled(Box)({
  border: '1px solid #E6E6E6',
  borderRadius: '4px',
  display: 'grid',
  gridTemplateColumns: '8fr 1fr 2fr',
  gap: '16px',
  padding: '16px 24px',
  maxWidth: '820px',
});

export const BenefitsPreviewPageContentV2 = styled(Box)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  lineClamp: '2',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
});

export const BenefitsPreviewCategoryContainerV2 = styled(Box)({
  '.preview-item-v2': { marginBottom: '8px' },
  '.preview-item-v2:last-child': {
    marginBottom: '0',
  },
});

export const PageContentWrapperV2 = styled(Box)({
  button: {
    color: 'black',
    marginLeft: '-18px',
  },
});

export const StyledSavviTransluscentContainer = styled(Box)({
  border: '1px solid #AE71FF',
  backgroundColor: 'rgba(174, 113, 255, .1)',
  borderRadius: '8px',
  padding: '32px 40px',
  marginBottom: '24px',
});
